import React, { useState, useEffect } from 'react';
import styles from './testcase.module.scss';
import { KoButton, KoForm, KoLoader, KoModal, KoTable, KoText, KoTitle, KoToast, KoTooltips } from 'packages';
import { TESTCASE_COLUMNS } from './constant';
import KoIcon from '@kwapio/icons';
import { DevelopmentAPI } from '../development.service';
import TestCaseCrud from 'pages/testcases/crud';
export default function TestCase({workspaceId, ticketId}) {
  const [loading, setLoading] = useState(false);
  const [currentRecord, setCurrentRecord] = useState();
  const [isOpen, setModal] = useState(false);
  const [form] = KoForm.useForm();
  const [isOpenDelete, setDeleteModal] = useState(false);

  const [testCasesList, settestCasesList] = useState([{
    caseId: 1,
    name: 'testcase1',
    description: [
      {
        type: "paragraph",
        children: [{ text: 'text' }]
      }
    ],
    status: 0,
    priority: 1
  }]);
  const [, setTotalCount] = useState(0);
  const [pagination] = useState({
    page: 1,
    limit: 100
  });

  useEffect(() => {
    // setLoading(true);
    getTestCases();
   
  }, []);

  const getTestCases = () => {
    setLoading(true);
    DevelopmentAPI.getTestCasesByTiocket(ticketId, workspaceId, pagination).then(
      (data) => {
        setLoading(false);
        settestCasesList(data?.data);
        setTotalCount(data?.totalCount);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const handleDelete = () => {
    setLoading(true);
    DevelopmentAPI.deleteTestcase(ticketId, currentRecord?.caseId, workspaceId).then(
      (data) => {
        setLoading(false);
        setDeleteModal(false);
        KoToast.success("Testcase Deleted Successfully");
        getTestCases();
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const handleFinish = (values => {
    setLoading(true);
    DevelopmentAPI.createOrUpdateTestcase(ticketId, values, currentRecord?.caseId, workspaceId).then(
      (data) => {
        getTestCases();
        setLoading(false);
        setModal(false);
        form.resetFields();
        KoToast.success(`Testcase ${currentRecord?.caseId ? 'updated':'created'} Successfully`);

      },

      (err) => {
        setLoading(false);
      }
    );
  });

  const columnsRight = [{
    title: '',
    dataIndex: 'x',
    key: 'x',
    fixed: 'right',
    width: 40,
    render: (text, row) => {
      return <div className={`${styles.table} tableBtn columnsRight`} onClick={() => {setCurrentRecord(row); setDeleteModal(true);}}>
        <KoTooltips title={'Delete'}>
          <KoButton className={'btn'} iconBtn={true}  icon={<KoIcon width={14} height={14} name={'DeleteOutlined'} />} />
        </KoTooltips>
      </div>;
    }
  }];
  
  return (
    <div className={styles.wrapper}>
      {loading && <KoLoader  />}
      <div className={styles.header}>
        <KoTitle text="Test Case" level={5} />
        <KoButton text="Create"  type="primary" onClick={() => setModal(true)}/>
      </div>
      <div className={styles.table}>
        <KoTable rowKey={'uid'}
          data={{ columns: TESTCASE_COLUMNS, rows: testCasesList }}
          extraColumnsRight={columnsRight}
          maxHeight={79} />
      </div>
      {isOpen && <TestCaseCrud
        isOpen={isOpen}
        form={form}
        ticketId={ticketId}
        workspaceId={workspaceId}
        initialValues={currentRecord}
        handleFinish={handleFinish}
        setCurrentRecord={()=>setCurrentRecord()}
        setModal={()=>setModal(false)}
      />}

      <KoModal
        title={`Delete ${currentRecord?.caseId?.toUpperCase()} Testcase `}
        centered
        open={isOpenDelete}
        afterClose={() => {setCurrentRecord();}}
        handleOk={() => { setCurrentRecord(); setDeleteModal(false); }}
        onClose={() => { setCurrentRecord(); setDeleteModal(false); }}
        width={580}
        // maskClosable={false}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setDeleteModal(!isOpenDelete)} />,
          <KoButton key='delete' color="danger" variant="solid"  type='primary' label='Delete' onClick={() => handleDelete()} />
        ]}
      >
        <div className={styles.delWrapper}>
          <KoTitle level={5} text={`This action will delete item and cannot be undone`} />
          <KoText text={`Do you wish to proceed?`} />
        </div>
      </KoModal>
        
    </div>
  );
}